import request from '@/utils/request'

// 查询师傅/社区列表（不分页）
export function listWorker(query) {
  return request({
    url: '/homeservice/worker/page',
    method: 'post',
    data: query
  }).then(res => {
    // 返回列表数据
    return {
      data: res.data ? res.data.records : []
    }
  })
}
